var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spin-button"},[_c('button',{class:['spin-button__click', { 'spin-button__click--disabled': _vm.isSpinning }],on:{"click":_vm.onClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }